var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 39,
    rx: 8,
    fill: "#FF9F2D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2352 9.17593C22.1158 8.60802 19.8842 8.60802 17.7648 9.17593C17.0979 9.3546 16.4125 8.95888 16.2338 8.29204C16.0552 7.62521 16.4509 6.93979 17.1177 6.76111C19.661 6.07963 22.339 6.07963 24.8823 6.76111C25.5491 6.93979 25.9448 7.62521 25.7662 8.29204C25.5875 8.95888 24.9021 9.3546 24.2352 9.17593ZM28.32 9.5435C28.7375 8.99369 29.5217 8.88645 30.0715 9.30395C31.6605 10.5106 32.9928 12.0221 33.9904 13.75C34.3356 14.3479 34.1307 15.1124 33.5328 15.4575C32.935 15.8027 32.1705 15.5979 31.8253 15C30.994 13.5601 29.8837 12.3005 28.5596 11.295C28.0098 10.8775 27.9025 10.0933 28.32 9.5435ZM21 12.5C16.1675 12.5 12.25 16.4175 12.25 21.25C12.25 26.0825 16.1675 30 21 30C25.8325 30 29.75 26.0825 29.75 21.25C29.75 16.4175 25.8325 12.5 21 12.5ZM9.75 21.25C9.75 15.0368 14.7868 10 21 10C27.2132 10 32.25 15.0368 32.25 21.25C32.25 27.4632 27.2132 32.5 21 32.5C14.7868 32.5 9.75 27.4632 9.75 21.25ZM14.75 21.25C14.75 20.5596 15.3096 20 16 20H26C26.6904 20 27.25 20.5596 27.25 21.25C27.25 21.9404 26.6904 22.5 26 22.5H16C15.3096 22.5 14.75 21.9404 14.75 21.25Z",
    fill: "#FF9F2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLate);
export default __webpack_public_path__ + "static/media/late.2b5fbdc1dfa95c96cc71f1474f64b6a0.svg";
export { ForwardRef as ReactComponent };